import {
  GET_CURRANCIES_RESPONSE,
  GET_BRANCHES_LOOKUP_RESPONSE,
  GET_PROVIDERS_LOOKUP_RESPONSE,
  GET_SERVICES_LOOKUP_RESPONSE,
  GET_SPECIALITIES_LOOKUP_REASPONSE,
} from './types';

const INITIAL_STATE = {
  currancies: null,
  branches: [],
  providers: [],
  services: null,
  specialties: null,
  employees: null,
  categories: null,
};

const lookUps = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CURRANCIES_RESPONSE:
      return {
        ...state,
        currancies: action.payload,
      };
    case GET_SPECIALITIES_LOOKUP_REASPONSE:
      return {
        ...state,
        specialties: action.payload,
      }
    case GET_SERVICES_LOOKUP_RESPONSE:
      return {
        ...state,
        services: action.payload,
      };
    case GET_BRANCHES_LOOKUP_RESPONSE:
      return {
        ...state,
        branches: action.payload,
      };
    case GET_PROVIDERS_LOOKUP_RESPONSE:
      return {
        ...state,
        providers: action.payload,
      };
    default:
      return state;
  }
};

export default lookUps;
